// imageData.ts

import pic_01 from "../assets/source/pic_01.jpg";
import pic_02 from "../assets/source/pic_02.jpg";
import pic_03 from "../assets/source/pic_03.jpg";
import pic_04 from "../assets/source/pic_04.jpg";
import pic_05 from "../assets/source/pic_05.jpg";
import pic_06 from "../assets/source/pic_06.jpg";
import pic_07 from "../assets/source/pic_07.jpg";
import pic_08 from "../assets/source/pic_08.jpg";
import pic_09 from "../assets/source/pic_09.jpg";
import pic_10 from "../assets/source/pic_10.jpg";
import pic_11 from "../assets/source/pic_11.jpg";
import pic_12 from "../assets/source/pic_12.jpg";
import pic_13 from "../assets/source/pic_13.png";
import pic_14 from "../assets/source/pic_14.jpg";
import pic_15 from "../assets/source/pic_15.jpg";
import pic_16 from "../assets/source/pic_16.jpg";
import pic_17 from "../assets/source/pic_17.jpg";
import pic_18 from "../assets/source/pic_18.jpg";
import pic_19 from "../assets/source/pic_19.jpg";
import pic_20 from "../assets/source/pic_20.jpg";
import pic_21 from "../assets/source/pic_21.png";
import pic_22 from "../assets/source/pic_22.jpeg";
import pic_23 from "../assets/source/pic_23.jpg";
import pic_24 from "../assets/source/pic_24.jpg";
import pic_25 from "../assets/source/pic_25.png";
import pic_26 from "../assets/source/pic_26.png";
import pic_27 from "../assets/source/pic_27.png";
import pic_28 from "../assets/source/pic_28.jpg";
import pic_29 from "../assets/source/pic_29.jpg";
import pic_30 from "../assets/source/pic_30.jpg";
import pic_31 from "../assets/source/pic_31.jpg";
import pic_32 from "../assets/source/pic_32.jpg";
import pic_33 from "../assets/source/pic_33.jpg";
import pic_34 from "../assets/source/pic_34.jpg";
import pic_35 from "../assets/source/pic_35.jpg";
import pic_36 from "../assets/source/pic_36.jpg";
import pic_37 from "../assets/source/pic_37.jpg";
import pic_38 from "../assets/source/pic_38.jpg";
import pic_39 from "../assets/source/pic_39.jpg";



export interface ImageItem {
  src: string;
  alt: string;
  caption: string;
}



import our_style_1 from "../assets/our_style_1.jpg";
import our_style_2 from "../assets/our_style_2.jpg";
import our_style_3 from "../assets/our_style_3.jpg";
import our_style_4 from "../assets/our_style_4.jpg";
import our_style_5 from "../assets/our_style_5.jpg";

export const ourStyles: ImageItem[] = [
  { src: our_style_1, alt: "", caption: "" },
  { src: our_style_2, alt: "", caption: "" },
  { src: our_style_3, alt: "", caption: "" },
  { src: our_style_4, alt: "", caption: "" },
  { src: our_style_5, alt: "", caption: "" }]

import Filtration_Accessories_25_01 from "../assets/filtrationaccessories/Filtration_Accessories_25_01.jpg";
import Filtration_Accessories_26_02 from "../assets/filtrationaccessories/Filtration_Accessories_26_02.jpg";
import Filtration_Accessories_26_03 from "../assets/filtrationaccessories/Filtration_Accessories_26_03.jpg";
import Filtration_Accessories_27_02 from "../assets/filtrationaccessories/Filtration_Accessories_27_02.jpg";
import Filtration_Accessories_27 from "../assets/filtrationaccessories/Filtration_Accessories_27.png";
import Filtration_Accessories_28 from "../assets/filtrationaccessories/Filtration_Accessories_28.jpg";

// Filtration Accessories Gallery Images
export const filtrationAccessoriesGallery: ImageItem[] = [
  { src: Filtration_Accessories_25_01, alt: "Filtration Accessories", caption: "" },
  { src: Filtration_Accessories_26_03, alt: "Bag Cages", caption: "" },
  { src: Filtration_Accessories_26_02, alt: "Filter Bags", caption: "" },
  { src: Filtration_Accessories_27, alt: "Dust Collection Systems", caption: "" },
  { src: Filtration_Accessories_27_02, alt: "Industrial Filtration", caption: "" },
  { src: Filtration_Accessories_28, alt: "Industrial Filtration", caption: "" }]

import Filtration_Accessories_show_06 from "../assets/beltconveyorsystem/show_06.jpg";
import Filtration_Accessories_IMG_7539 from "../assets/beltconveyorsystem/IMG_7539.JPG";
import Filtration_Accessories_show_07 from "../assets/beltconveyorsystem/show_07.jpg";
import Filtration_Accessories_MobileStackerConveyor_01 from "../assets/beltconveyorsystem/MobileStackerConveyor_01.JPG";
import Filtration_Accessories_MobileStackerConveyor_03 from "../assets/beltconveyorsystem/MobileStackerConveyor_03.JPG";
import Filtration_Accessories_IMG_7548 from "../assets/beltconveyorsystem/IMG_7548.JPG";
import Filtration_Accessories_IMG_7545 from "../assets/beltconveyorsystem/IMG_7545.JPG";
import Filtration_Accessories_IMG_7546 from "../assets/beltconveyorsystem/IMG_7546.JPG";
import Filtration_Accessories_IMG_7550 from "../assets/beltconveyorsystem/IMG_7550.JPG";


// Belt Conveyor System Gallery Images
export const beltConveyorGallery: ImageItem[] = [
  { src: Filtration_Accessories_show_06, alt: "Belt Conveyor System", caption: "" },
  { src: Filtration_Accessories_IMG_7539, alt: "Heavy-duty Belt Conveyor", caption: "" },
  { src: Filtration_Accessories_show_07, alt: "Modular Conveyor Design", caption: "" },
  { src: Filtration_Accessories_MobileStackerConveyor_01, alt: "ISO-certified Conveyor", caption: "" },
  { src: Filtration_Accessories_MobileStackerConveyor_03, alt: "Industrial Material Handling", caption: "" },
  { src: Filtration_Accessories_IMG_7548, alt: "Modular Conveyor Design", caption: "" },
  { src: Filtration_Accessories_IMG_7545, alt: "ISO-certified Conveyor", caption: "" },
  { src: Filtration_Accessories_IMG_7546, alt: "Modular Conveyor Design", caption: "" },
  { src: Filtration_Accessories_IMG_7550, alt: "ISO-certified Conveyor", caption: "" },]

// Dust Removal System Gallery Images
export const dustRemovalGallery: ImageItem[] = [
  { src: "/images/categorydetail/dustremovalsystem/Pulse_Jet_Dust_Collector_02_01.png", alt: "Pulse Jet Dust Collector", caption: "" },
  { src: "/images/categorydetail/dustremovalsystem/Pulse_Jet_Dust_Collector_02_02.png", alt: "Industrial Dust Control", caption: "" },
  { src: "/images/categorydetail/dustremovalsystem/Pulse_Jet_Dust_Collector_03_01.png", alt: "Baghouse Dust Collector", caption: "" },
  { src: "/images/categorydetail/dustremovalsystem/Pulse_Jet_Dust_Collector_03_02.png", alt: "Dust Collection System", caption: "" },
  { src: "/images/categorydetail/dustremovalsystem/Pulse_Jet_Dust_Collector_04_01.png", alt: "Heavy-duty Dust Removal", caption: "" },
  { src: "/images/categorydetail/dustremovalsystem/Pulse_Jet_Dust_Collector_04_02.png", alt: "Dust Filtration System", caption: "" },]

// Steel Structures Gallery Images
export const steelStructuresGallery: ImageItem[] = [
  { src: "/images/categorydetail/steelstructure/liqingchuchen_01.jpg", alt: "Modular Steel Frame", caption: "" },
  { src: "/images/categorydetail/steelstructure/liqingchuchen_02.jpg", alt: "Industrial Steel Tower", caption: "" },
  { src: "/images/categorydetail/steelstructure/liqingzaisheng_01.jpg", alt: "Heavy-duty Steel Structure", caption: "" },
  { src: "/images/categorydetail/steelstructure/liqingzaisheng_02.jpg", alt: "Steel Fabrication", caption: "" },
  { src: "/images/categorydetail/steelstructure/zhishajigou_01.jpg", alt: "Custom Steel Components", caption: "" }]






const baseWidth = 0.8;
const baseHeight = 1.2;

const getRandomDelay = () => `${Math.random() * 1}s`; // 如果你已有，保持一致
const getRandomScale = () => (Math.random() < 0.5 ? 1 : 1.5);

// 可导出一个函数
export const generateSmallImages = (dotSrc: string) => {
  const positions = [
    { top: "48%", left: "13%" },
    { top: "16%", left: "43%" },
    { top: "33%", left: "24%" },
    { top: "29%", left: "39%" },
    { top: "54%", left: "36.5%" },
    { top: "52%", left: "29.5%" },
    { top: "19%", left: "34.5%" },
    { top: "57%", left: "23%" },
    { top: "64%", left: "28%" },
    { top: "44%", left: "18%" },
  ];

  return positions.map((pos) => {
    const scale = getRandomScale();
    const width = baseWidth * scale;
    const height = baseHeight * scale;

    return {
      src: dotSrc,
      style: {
        top: pos.top,
        left: pos.left,
        animationDelay: getRandomDelay(),
        width: `${width}vw`,
        height: `${height}vw`,
      },
    };
  });
};

// 移动端专用的小图片生成函数
export const generateSmallImagesForMobile = (dotSrc: string) => {
  const mobilePositions = [
    { top: "20%", left: "85%" },
    { top: "30%", left: "70%" },
    { top: "35%", left: "55%" },
    { top: "34%", left: "75%" },
    { top: "50%", left: "45%" },
    { top: "55%", left: "20%" },
    { top: "65%", left: "70%" },
    { top: "75%", left: "65%" },
    { top: "55%", left: "60%" },
    { top: "45%", left: "67%" },
    { top: "45%", left: "73%" },
  ];

  return mobilePositions.map((pos) => {
    const scale = getRandomScale();
    const width = baseWidth * scale * 1.2; // 从 0.8 增加到 1.2，放大50%
    const height = baseHeight * scale * 1.2;

    return {
      src: dotSrc,
      style: {
        top: pos.top,
        left: pos.left,
        animationDelay: getRandomDelay(),
        width: `${width}vw`,
        height: `${height}vw`,
      },
    };
  });
};

//footer
import LinkedIn from "../assets/btn_ly.png";
import WhatsApp from "../assets/btn_whatsapp.png";
import LINE from "../assets/btn_line.png";
import Facebook from "../assets/btn_facebook.png";
import Instagram from "../assets/btn_instagram.png";
import X from "../assets/btn_x.png";

export const icons = [
  {
    src: LinkedIn,
    alt: "LinkedIn",
    url: "https://www.linkedin.com/company/107718920/",
  },
  {
    src: Facebook,
    alt: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61575843466910",
  },
  {
    src: X,
    alt: "X",
    url: "https://x.com/CrestonGroupGL",
  },
];

export const menuItems = [
  { label: "Home", path: "/" },
  { label: "Our Offers", path: "/core-offers" },
  { label: "About Us", path: "/about" },
  { label: "Contact Us", path: "/contact-us" },
  { label: "Privacy Policy", path: "/privacy-policy" },
];

import { useRouter } from "vue-router";
import sourceandProcurement from "../assets/bg_offers_1.png";
import imgMae from "@/assets/img_offers_mae.png";
import imgTlp from "@/assets/img_offers_tlp.png";
import imgRdg from "@/assets/img_offers_rdg.png";

//core-offers
export const offerItems = [
  {
    img: imgMae,
  },
  {
    img: imgTlp,
  },
  {
    img: imgRdg,
  },
];



import img_ecc from "../assets/img_offers_eec.png";
import img_ism from "../assets/img_offers_ism.png";
import img_ts from "../assets/img_offers_ts.png";

import icn_ecc from "../assets/icn_offers_eec.png";
import icn_ism from "../assets/icn_offers_ism.png";
import icn_ts from "../assets/icn_offers_ts.png";



export const cards = [
  {
    img: img_ecc,
    icon: icn_ecc,
    alt: "EEC",
  },
  {
    img: img_ism,
    icon: icn_ism,
    alt: "ISM",
  },
  {
    img: img_ts,
    icon: icn_ts,
    alt: "TS",
  },
];


export const locations = [
  "Canada",
  "China",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Iceland",
  "Indonesia",
  "Ireland",
  "Italy",
  "Japan",
  "Korea",
  "Latvia",
  "Lithuania",
  "Luxembourg",
  "Malaysia",
  "Mexico",
  "Myanmar",
  "Netherlands",
  "Norway",
  "Philippines",
  "Poland",
  "Portugal",
  "Russia",
  "Scotland",
  "Spain",
  "Sweden",
  "Thailand",
  "United Kingdom",
  "United States",
  "Vietnam",
  "Other",
];

import strengths_1 from "../assets/strengths_1.png";
import strengths_2 from "../assets/strengths_2.png";
import strengths_3 from "../assets/strengths_3.png";
import strengths_4 from "../assets/strengths_4.png";
import strengths_5 from "../assets/strengths_5.png";
import strengths_6 from "../assets/strengths_6.png";
import strengths_7 from "../assets/strengths_7.png";
import strengths_8 from "../assets/strengths_8.png";
import strengths_9 from "../assets/strengths_9.png";
import strengths_10 from "../assets/strengths_10.png";
export const strengths = [
  {
    image: strengths_1,
  },
  {
    image: strengths_2,
  },
  {
    image: strengths_3,
  },
  {
    image: strengths_4,
  },
  {
    image: strengths_5,
  },
  {
    image: strengths_6,
  },
  {
    image: strengths_7,
  },
  {
    image: strengths_8,
  },
  {
    image: strengths_9,
  },
  {
    image: strengths_10,
  },
];

// 导出 imageSources 数组
export const imageSources = [
  pic_01, pic_02, pic_03, pic_04, pic_05, pic_06, pic_07, pic_08, 
  pic_09, pic_10, pic_11, pic_12, pic_13, pic_14, pic_15, pic_16,
  pic_17, pic_18, pic_19, pic_20, pic_21, pic_22, pic_23, pic_24,
  pic_25, pic_26, pic_27, pic_28, pic_29, pic_30, pic_31, pic_32,
  pic_33, pic_34, pic_35, pic_36, pic_37, pic_38, pic_39
];

